import { Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import SoftTypography from "components/SoftTypography";
import React, { useEffect, useState } from "react";
import TicketTabs from "./components/tabs/index.js";
import SoftSelect from "components/SoftSelect/index.js";
import Plan from "./components/Plan/index.js";
import Features from "./components/Features";
import ChurnedReasons from "./components/ChurnedReasons";
import { useAppServices } from "hook/services.js";
import dataTableData from "./components/data/plan";
import Loader from "examples/Loader/index.js";
import { useAgencyInfo } from "context/agency.js";
function index() {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const [agency, update] = useAgencyInfo();
  const AppService = useAppServices();
  const [loader, setLoader] = useState(true);
  const [superadmin_data, setsuperadmin_data] = useState([]);
  const GetSettings = async () => {
    const { response } = await AppService.health_features.getsettings();
    if (response) {
      setLoader(false);
      setsuperadmin_data(response.data);
    } else {
      setLoader(false);
    }
  };

  const handleDefaultPlan = async (e) => {
    const payload = {
      _id: agency._id,
      default_plan: e.value + "-" + e.label + "-" + e.color,
    };
    const { response } = await AppService.agency.update({
      payload,
    });
    update(response.data)
  };

  const onLoad = () => {
    GetSettings();
  };
  useEffect(() => {
    onLoad();
  }, []);
  return (
    <PageLayout>
      {loader ? (
        <Loader />
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              sx={{
                boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
                border: "1px solid #cfd7df",
                borderRadius: "8px",
                marginRight: "1em",
              }}
            >
              <SoftBox
                p={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={"10px"}
              >
                <SoftTypography variant="h5">Health </SoftTypography>
                <SoftSelect
                  onChange={(e) => handleDefaultPlan(e)}
                  placeholder="Select Default Plan.."
                  defaultValue={{ value: agency?.default_plan?.split("-")[0], label: agency?.default_plan?.split("-")[1] }}
                  options={main_data.map((plan) => ({
                    label: plan.name,
                    value: plan._id,
                    color: plan.color,
                  }))}
                />
              </SoftBox>

              <SoftBox component="form">
                <Grid container spacing={3} paddingX={3} paddingBottom={4}>
                  <Grid item xs={12}>
                    <TicketTabs
                      elements={[
                        <Plan key={1} superadmin_data={superadmin_data.plans} data={data} processing={processing} handleRefresh={handleRefresh} main_data={main_data} />,
                        <Features key={2} superadmin_data={superadmin_data.features} />,
                        <ChurnedReasons key={2} superadmin_data={superadmin_data.churnedReasons} />,
                      ]}
                    />
                  </Grid>
                </Grid>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      )}
    </PageLayout>
  );
}

export default index;
